import React from "react";
import { Grid, Typography } from "@mui/material";
import TextInput from "./TextInput";

const PlanNameTab = (props) => {
  return (
    <Grid container spacing={3} className={"plan-name-step"}>
      <Grid item xs={12}>
        <Typography component={"h2"} variant={"h2"}>
          Congratulations, Plan Wizard is nearly finished. Let’s name this Plan
          before the final calculations.
        </Typography>
      </Grid>
      <Grid item xs={12}>
        <Typography component={"label"}>Enter Plan Name:</Typography>
        <TextInput
          placeholder="Enter a Plan Name"
          value={props.planName}
          isRequired={true}
          onChange={(event) => {
            props.setPlanName(event.target.value);
          }}
        />
      </Grid>
    </Grid>
  );
};

export default PlanNameTab;
